// extracted by mini-css-extract-plugin
module.exports = {"handWriting":"free-handwriting_handWriting__2mzL9","right":"free-handwriting_right__57pGs","white":"free-handwriting_white__3xplm"};